import { type Msg } from '@halo/chat-sdk-react';
import { MessageBody } from '@halo/ui-chat-react';
import { useIsMyMsg } from '@/scripts/hooks';

// Message
export interface MsgBodyProps {
  message: Msg;
  children: React.ReactNode;
}

export const MsgBody = memo(function MsgBody({ message, children }: MsgBodyProps) {
  const isMyMessage = useIsMyMsg(message);
  return <MessageBody isMe={isMyMessage}>{children}</MessageBody>;
});
